import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { ApiService } from '../core/api.service';
import { UtilityService } from '../core/global/utility.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.sass']
})
export class ChangePasswordComponent implements OnInit {
  id
  email=[];
  user: any = {};
  constructor(private _adminService: ApiService,private route: ActivatedRoute,private _utility:UtilityService,private router: Router,) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getUserEmail();
  }
getUserEmail(){
  let url = "users/email";
  let data= {'id':this.id}
  this._adminService.login(url,data).subscribe((response)=>{
      if(response.success==true){
          this.user.email=response.data[0].email;
        //  if(!this.user.email || this.user==[]){
        //   this._utility.toastError('Link Expired');
        //  }
      }else{
        this._utility.toastError(response.message) ;
      }
  })
 }
 changePassword(){
  var error = 0;
  if(!this.user.newPassword){
    error++;
    this._utility.toastWarning('Enter New Password');
  }else if(!this.user.confirmPassword) {
    error++;
    this._utility.toastWarning('Enter Confirm New Password');
  }else if(this.user.newPassword!=this.user.confirmPassword) {
    error++;
    this._utility.toastWarning('Password Did Not Match');
  }
  if(error==0) {
  let url = 'users/change-pass';
  this._adminService.login(url,this.user).subscribe((response)=>{
      if(response.success==true){
        this._utility.toastSuccess (response.message);
        this.router.navigate(['login']);
      }else{
        this._utility.toastError(response.message) ;
      }
    })
   }
 }
}
